<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-message-processing" icon-small title="لیست قالب های پیامک" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-tabs v-model="activeTab" @change="tabChanged" background-color="transparent" centered slider-color="yellow">
						<v-tab :key="0">قالب های در انتظار تایید ({{pendingPatterns.length}})</v-tab>
						<v-tab :key="1">همه قالب ها ({{countAll}})</v-tab>

						<v-tabs-items v-model="activeTab" touchless>
							<v-tab-item :key="0">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="pendingPatterns" :items-per-page="500" :search="search" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div>{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>
							<v-tab-item :key="1">
								<v-row>
									<v-col cols="12" lg="12">
										<v-text-field v-model="search2" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
									</v-col>
									<v-col cols="12">
										<v-data-table dense :headers="headers" :items="allPatterns" :items-per-page="500" :search="search2" class="elevation-1">
											<template v-slot:item="row">
												<tr>
													<td>
														<div>{{ row.item.customer.name }}</div>
														<div class="grey--text">{{ row.item.customer.mobile }}</div>
													</td>
													<td>
														{{ row.item.title }}
													</td>
													<td>
														<div style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
															{{ row.item.pattern }}
														</div>
													</td>
													<td class="text-center">
														{{ row.item.isSystem ? 'بلی' : 'خیر' }}
													</td>
													<td class="text-center">
														{{ translateStatus(row.item.status) }}
													</td>
													<td style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden;max-width:200px">
														{{ row.item.rejectReason }}
													</td>
													<td class="text-center">
														<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
															<v-icon dark>
																mdi-square-edit-outline
															</v-icon>
														</v-btn>
														<v-btn class="mx-1" fab dark small color="pink" @click="remove(row.item)">
															<v-icon dark>
																mdi-trash-can-outline
															</v-icon>
														</v-btn>
													</td>
												</tr>
											</template>
										</v-data-table>
									</v-col>
								</v-row>
							</v-tab-item>

						</v-tabs-items>
					</v-tabs>

				</v-col>
			</v-row>
			<v-dialog v-model="dialogPattern" scrollable persistent max-width="450px">
				<v-card>
					<v-card-title>
						<span class="headline">مشخصات قالب پیامک</span>
						<v-spacer />
						<v-btn @click="dialogPattern = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-form ref="form" class="mx-2" lazy-validation>
							<v-container>
								<v-row>
									<v-col cols="12">
										<v-text-field v-model="localData.title" outlined label="عنوان قالب*" :error-messages="errorMessages" :rules="[() => !!localData.title || 'عنوان قالب را وارد کنید']" required />
									</v-col>
									<v-col>
										<v-textarea v-model="localData.pattern" outlined :error-messages="errorMessages" label="الگوی قالب*" :rules="[() => !!localData.pattern || 'قالب را وارد کنید']" required />
										<div style="font-size: 0.8rem;" class="mb-2">
											<div>نمونه پیامک:</div>
											<div v-html="sampleText" style="white-space: pre-line;">

											</div>
										</div>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12">
										<v-textarea v-model="localData.rejectReason" outlined :error-messages="errorMessages" label="دلیل رد" />
									</v-col>
								</v-row>
							</v-container>
						</v-form>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn color="blue" dark @click="submit(1)">
							تائید شود
						</v-btn>
						<v-btn color="red" dark @click="submit(2)">
							رد شود
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MembersView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				activeTab: 0,
				countAll: 0,
				allPatternsFetched: false,
				pendingPatternsFetched: false,
				errorMessages: '',
				datePickerValidatioin: '',
				localData: {},
				selectedPattern: {},
				dialogPattern: false,
				search: '',
				search2: '',
				loading: false,
				headers: [
					{
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'firstName',
						width: 150
					}, {
						text: 'عنوان',
						align: 'start',
						sortable: true,
						value: 'title',
						width: 150
					}, {
						text: 'قالب',
						align: 'start',
						sortable: true,
						value: 'pattern',
					}, {
						text: 'سیستمی',
						align: 'center',
						sortable: true,
						value: 'isSystem',
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status',
						width: 100
					}, {
						text: 'دلیل رد',
						align: 'start',
						sortable: true,
						value: 'rejectReason',
						width: 200,
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
				allPatterns: [],
				pendingPatterns: [],
				patternTags: ['{نام مشتری}', '{نام فروشگاه}', '{مبلغ قسط}', '{مبلغ واریز}', '{تاریخ واریز}', '{مانده وام}', '{لینک پرداخت}'],
				replace: {
					'{نام مشتری}': 'مهدی قاسمی فرد',
					'{نام فروشگاه}': 'فروشگاه قاسمی فرد',
					'{مبلغ قسط}': 550000,
					'{مبلغ واریز}': 550000,
					'{تاریخ واریز}': '1402-01-30',
					'{مانده وام}': 6500000,
					'{لینک پرداخت}': 'https://jetaqsaat.ir/pay/100/1323213',
				}
			}
		},
		computed: {
			sampleText() {
				return this.convertPatternToSample(this.localData?.pattern)
			},
		},
		mounted() {
			this.tabChanged(0)
		},
		methods: {
			convertPatternToSample(pattern) {
				const replaceAll = (str, find, replace) => {
					return str.toString().replace(new RegExp(find, 'g'), replace)
				}
				if (!pattern)
					return ''
				for (var tag of this.patternTags) {
					pattern = replaceAll(pattern, tag, this.replace[tag])
				}
				return pattern
			},
			loadData(all) {
				this.loading = true
				let data = all || false
				api.get('superadmin/SmsPattern/list/' + data, null)
					.then(
						response => {
							if (all) {
								this.allPatterns = response.smsPatterns
								this.countAll = response.countAll
								this.allPatternsFetched = true
							} else {
								this.pendingPatterns = response.smsPatterns
								this.countAll = response.countAll
								this.pendingPatternsFetched = true
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			edit(item) {
				api.get('superadmin/SmsPattern/get/' + item.id, null)
					.then(
						response => {
							this.localData = response
							this.dialogPattern = true
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			submit(status) {
				if (!this.$refs.form.validate()) { return }

				let data = { ...this.localData }
				data.status = status
				api.post('superadmin/SmsPattern/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.loadData(this.activeTab == 1)
							this.dialogPattern = false
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('superadmin/SmsPattern/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.allPatternsFetched = false
								this.pendingPatternsFetched = false
								this.pendingPatterns = this.activeTab == 1 ? [] : this.pendingPatterns
								this.allPatterns = this.activeTab == 0 ? [] : this.allPatterns
								this.loadData(this.activeTab == 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			tabChanged(tab) {
				if (tab == 1 && !this.allPatternsFetched)
					this.loadData(true)
				else if (tab == 0 && !this.pendingPatternsFetched)
					this.loadData(false)
			},
			translateStatus(status) {
				switch (status) {
					case 0:
						return 'در انتظار بررسی'
					case 1:
						return 'تائید شده'
					case 2:
						return 'رد شده'
					default:
						break
				}
			},
			updatePattern(pattern) {

			}
		},
	}
</script>
<style>
</style>
